import { Flex } from "@chakra-ui/react";
import DsrPostTextAreaInput from '../../forms/TextareaField/components/DsrPostTextAreaInput';
import LaunchdeckModal from "../../global/components/helper-components/components/LaunchdeckModal";


export default function DsrEditReplyModal({
  dsrId,
  handleCloseModal,
  handleEditPostReply,
  editDsrFeedReplyOutcome,
  showDsrModalLoader,
  modalTransferPayload
}) {

  const replyObjectState = modalTransferPayload?.replyObject || null

  return (
    <LaunchdeckModal
      title={`Edit reply`}
      handleCloseModal={handleCloseModal}
      showModal={true}
      maxW='35em'
    >

      <Flex w='100%' px='0.5em'>
        <DsrPostTextAreaInput
          userActionRequired='edit-dsr-reply'
          name="updatePostReplyContent"
          sublabel=""
          placeholder=""
          currentValue={replyObjectState?.replyContent}
          fontSize='1em'
          htmlFor="updatePostReplyContent"
          onClickEditPost={handleEditPostReply}
          editDsrFeedReplyOutcome={editDsrFeedReplyOutcome}
          dsrId={dsrId}
          postId={modalTransferPayload?.postIdToEdit}
          replyId={replyObjectState?.replyId}
          isLoading={showDsrModalLoader}
        />
      </Flex>
    </LaunchdeckModal>
  )
}
